import React from 'react';

import {
  FontAwesomeIcon,
  Button,
  WithPopover,
} from '@schoolinks/ui-components';
import { useNavigate } from 'react-router-dom';

import { faRightFromBracket } from '@fortawesome/pro-regular-svg-icons/faRightFromBracket';

import useModal from 'hooks/useModal';

import { LOGOUT } from 'routes/constants';

import s from './Logout.css';

const LogoutButton = () => {
  const navigate = useNavigate();
  const { hideModal } = useModal();

  return (
    <WithPopover
      classes={{
        paper: s.popover,
      }}
      popoverContent={({ setAnchor }) => (
        <>
          <h6 className={s.logoutText}>
            Are you sure you want to log out of SchooLinks?
          </h6>
          <div className={s.dFlex}>
            <Button
              onClick={() => setAnchor(null)}
              withShadow
              label="No, stay here"
              variant="outlined"
            />
            <Button
              variant="outlined"
              withShadow
              iconDirection="right"
              color="secondary"
              icon={<FontAwesomeIcon icon={faRightFromBracket} size="lg" />}
              onClick={() => {
                hideModal();
                navigate(LOGOUT);
              }}
              label="Yes, log me out"
            />
          </div>
        </>
      )}
      tooltipProps={{
        title: 'Sign off',
      }}
      aria-label="Sign off"
      anchorContent={() => (
        <div className={s.logoutBtn}>
          <FontAwesomeIcon icon={faRightFromBracket} size="lg" />
        </div>
      )}
    />
  );
};

export default LogoutButton;
